import React from 'react';
import { InfoTooltip } from '@/components/common/InfoTooltip';

export interface MetricCardProps {
  icon: React.ReactNode;
  value: React.ReactNode;
  label: React.ReactNode;
  subLabel?: React.ReactNode;
  tooltipText?: string;
  variant?: 'default' | 'danger';
}

export const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  value,
  label,
  subLabel,
  tooltipText,
  variant = 'default',
}) => (
  <div
    className={`relative rounded-xl border p-4 flex flex-col gap-1 ${
      variant === 'danger'
        ? 'bg-red-50 border-red-200'
        : 'bg-white border-gray-200'
    }`}
  >
    <div className="flex items-start justify-between mb-1">
      <span
        className={`flex items-center justify-center w-8 h-8 rounded-xl ${
          variant === 'danger' ? 'bg-red-100' : 'bg-gray-100'
        }`}
      >
        {icon}
      </span>
      {tooltipText && <InfoTooltip text={tooltipText} placement="top" />}
    </div>
    <div className={`text-2xl font-bold leading-tight ${variant === 'danger' ? 'text-red-600' : 'text-gray-900'}`}>
      {value}
    </div>
    <div className={`text-sm font-medium ${variant === 'danger' ? 'text-red-700' : 'text-gray-600'}`}>
      {label}
    </div>
    {subLabel && <div className="text-xs text-gray-400 mt-0.5">{subLabel}</div>}
  </div>
);
